import type { StreamdownProps } from "streamdown";

/** Light/dark Shiki pair for Streamdown code blocks (switches via `dark:` CSS). */
export const streamdownShikiTheme: NonNullable<StreamdownProps["shikiTheme"]> =
  ["github-light", "andromeeda"];
